var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAiStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5186 21.008C11.1586 18.944 9.69459 16.352 6.91059 14.264C5.54259 13.232 4.15059 12.56 2.78259 12.272V11.264C5.49459 10.616 8.15859 8.792 9.86259 6.32C10.7266 5.072 11.2786 3.848 11.5186 2.576H12.5266C12.9346 5 14.8066 7.688 17.3506 9.488C18.5986 10.376 19.8946 10.976 21.2146 11.264V12.272C18.5506 12.824 15.4546 15.2 13.9186 17.624C13.1506 18.848 12.6946 19.976 12.5266 21.008H11.5186Z",
    fill: "#656EFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiStar);
export default __webpack_public_path__ + "static/media/ai_star.341973ce9389c973782f0832a5ec8b38.svg";
export { ForwardRef as ReactComponent };